// extracted by mini-css-extract-plugin
export var logo = "logosWrapped-module--logo--d5d22";
export var logo_title = "logosWrapped-module--logo_title--90f03";
export var logos_list = "logosWrapped-module--logos_list--970f3";
export var logos_list__large = "logosWrapped-module--logos_list__large--62222";
export var logos_list__normal = "logosWrapped-module--logos_list__normal--d8406";
export var logos_list__small = "logosWrapped-module--logos_list__small--0c4d8";